export default __webpack_public_path__ + "static/media/Building-pana 1.85c2b2e6.svg";